import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { getExternalUserByExternalUserIdAsync, deleteExternalUserAsync, ResendVerificationEmailAsync, checkedAllState, unCheckedAllState, checkedState, unCheckedState, updateExternalUserAsync,updateSorting } from "./externalUserSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Link } from "react-router-dom";
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

export const ExternalUserItem = (props: any) => {
    const { modelRef, externalUserList, onopenModal, IsEdit, IsDelete } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    const { isLoading, sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.externalUser);
    const navigate = useNavigate();
    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountEmployeeId: number) => {
        dispatch(getExternalUserByExternalUserIdAsync(AccountEmployeeId))
            .unwrap()
            .then((originalPromiseResult) => {
                modelRef.current.click();
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getExternalUserByExternalUserIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const onDeleteClick = (AccountEmployeeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteExternalUserAsync(AccountEmployeeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("External user deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            console.log('onDeleteClick-deleteExternalUserAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }
    const onUnverifiedClick = (AccountEmployeeId: number) => {

        dispatch(ResendVerificationEmailAsync(AccountEmployeeId))
            .unwrap()
            .then((originalPromiseResult) => {

                ShowSwal('Email', 'Email resent successfully.', 'success');
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('ResendVerificationEmailAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountEmployeeType: any) => {
        const { checked } = e.target;
        const foundIndex = externalUserList.findIndex((item: any) => item.AccountEmployeeId === AccountEmployeeType.AccountEmployeeId);
        if (foundIndex !== -1) {
            const foundItem = externalUserList[foundIndex];
            const { isSelected, EmployeeName, CurrencySymbol, IsEmailVerified, ShowClockStartEnd, ClientCode, ClientName, CultureInfoName, TimeEntryFormat, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...externalUserList.slice(0, foundIndex), updatedItem, ...externalUserList.slice(foundIndex + 1)];
            dispatch(updateExternalUserAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("External user Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>

            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={externalUserList.every((item: any) => item.isSelected === 0) ? false :
                                            (externalUserList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                       <th style={{width:'15%'}}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                        {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'15%'}}>
                            {/* {t('User Name')} */}
                            {getValueFromResource('User Name',dispatch, t)}
                        {sortColumn === 'FirstName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "FirstName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "FirstName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "FirstName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "FirstName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-25'>
                            {/* {t('Email Address')} */}
                            {getValueFromResource('Email Address',dispatch, t)}
                        {sortColumn === 'EMailAddress' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EMailAddress") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EMailAddress") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EMailAddress") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EMailAddress") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-25'>
                            {/* {t('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                        {sortColumn === 'ClientName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ClientName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ClientName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ClientName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ClientName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {externalUserList.length > 0 && externalUserList.map((externalUserDetail: any, i: any) => (

                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={externalUserDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, externalUserDetail.AccountEmployeeId) }}

                                        />
                                    </div>
                                </td>
                            }
                             <td>
                                            <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(externalUserDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                                {externalUserDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                            </span>
                                        </td>
                             <td>
                                <a id={`${IsEdit ? 'kt_OffCanvas' : ''}`}
                                    className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    style={{ cursor: 'pointer' }}
                                    onClick={IsEdit ? () => onEditClick(externalUserDetail.AccountEmployeeId) : undefined}>
                                    {externalUserDetail.FirstName}  {externalUserDetail.LastName}
                                </a>
                            </td>
                            <td>
                                <span className="text-muted fw-semibold text-muted d-block fs-7">{externalUserDetail.EMailAddress}</span>
                                {externalUserDetail.IsEmailVerified === 'No' ?
                                    <span data-toggle="tooltip" data-theme="dark" title="Click To Resend Verification Email"
                                        className="badge badge-light-warning fs-7" onClick={() => { onUnverifiedClick(externalUserDetail.AccountEmployeeId) }}
                                        style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7' }} >
                                            
                                            {getValueFromResource('Unverified',dispatch, t)}
                                            </span> :
                                    <span className="badge badge-light-success fs-7" style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7' }}>
                                        {/* Verified */}
                                        {getValueFromResource('Verified',dispatch, t)}
                                        </span>}
                            </td>
                            <td><span className="">{externalUserDetail.ClientName}</span></td>
                            {/* {IsEdit &&
                                <td className='text-center'>

                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={externalUserDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, externalUserDetail) }}
                                        />
                                       
                                    </div>
                                </td>
                            } */}
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => onEditClick(externalUserDetail.AccountEmployeeId)}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit',dispatch, t)}

                                                            </span>
                                                    </Dropdown.Item>
                                                </div>

                                            </>
                                        }

                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0 "
                                            >
                                                <span className="menu-icon custom-menu">
                                                    <i className="bi bi-envelope-open fs-6 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                {/* <Link to={`../eMailNotificationPreferences?AccountEmployeeId=${externalUserDetail.AccountEmployeeId}`} >
                                                <span className="menu-title custom-menu-fontsize">{`${t('Email Preference')}`}</span>
                                                </Link> */}
                                                  <span className="menu-title custom-menu-fontsize"
                                                        onClick={() => navigate(`../eMailNotificationPreferences?AccountEmployeeId=${externalUserDetail.AccountEmployeeId}`)}
                                                    >
                                                        {/* {`${t('Email Preference')}`} */}
                                                        {getValueFromResource('Email Preference',dispatch, t)}
                                                    </span>
                                            </Dropdown.Item>
                                        </div>
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(externalUserDetail.AccountEmployeeId) }}>
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize" >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
            {externalUserList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }

        </>
    )


}
export default ExternalUserItem